import md5 from 'md5';

/**
 * Obtém a URL da foto do usuário com fallback
 * Prioridade: foto_url (upload) -> chatwoot_avatar_url -> Gravatar (baseado no email)
 * 
 * @param user - Objeto do usuário com foto_url, chatwoot_avatar_url e email
 * @returns URL da foto ou null
 */
export function getUserPhotoUrl(user: {
  foto_url?: string | null;
  chatwoot_avatar_url?: string | null;
  email?: string | null;
} | null): string | null {
  if (!user) return null;

  // Prioridade 1: Foto enviada via upload
  if (user.foto_url) {
    return user.foto_url;
  }

  // Prioridade 2: Avatar do Chatwoot
  if (user.chatwoot_avatar_url) {
    return user.chatwoot_avatar_url;
  }

  // Prioridade 3: Gravatar baseado no email
  if (user.email) {
    return getGravatarUrl(user.email);
  }

  return null;
}

/**
 * Obtém a URL do Gravatar para um email
 * Usa uma implementação simplificada que funciona no navegador
 * 
 * @param email - Email do usuário
 * @param size - Tamanho da imagem (padrão: 200)
 * @returns URL do Gravatar
 */
export function getGravatarUrl(email: string, size: number = 200): string {
  // Normalizar email
  const normalizedEmail = email.toLowerCase().trim();
  
  // Calcular hash MD5 do email para usar com Gravatar
  const emailHash = md5(normalizedEmail);
  
  // Retornar URL do Gravatar
  // d=404: retorna 404 quando não houver foto real, permitindo fallback para iniciais
  // s=size: tamanho da imagem
  return `https://www.gravatar.com/avatar/${emailHash}?d=404&s=${size}`;
}

/**
 * Obtém as iniciais do nome do usuário para usar como fallback
 * 
 * @param nomeCompleto - Nome completo do usuário
 * @returns Iniciais (ex: "João Silva" -> "JS")
 */
export function getUserInitials(nomeCompleto: string | null | undefined): string {
  if (!nomeCompleto) return "U";
  
  const names = nomeCompleto.trim().split(/\s+/);
  if (names.length === 0) return "U";
  
  if (names.length === 1) {
    return names[0].substring(0, 2).toUpperCase();
  }
  
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
}

